import React from 'react';
import {Col, Container, Row, Tab, Nav} from "react-bootstrap";

function Ourpractice(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="POS Solutions">
                            <h2>TekRevol’s Holistic POS Development Process</h2>
                        </div>
                        <p className="main_para">TekRevol has a holistically curated product development approach with a
                            strong emphasis on strategy and the right technology stack selection. All our processes aim
                            to create impact, and we work on diverse forms of innovation each day, from automating
                            analytics to hyper-scaling systems on the cloud.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Plan & Ideate</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Design & Develop</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Deploy & Automate</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <p>Different industries and niches have various use cases for POS systems.
                                                That’s the reason TekRevol prioritizes customization. In the first
                                                stage, we complete a comprehensive audit and identify the needs of the
                                                business while matching it with current revenue, business objectives and
                                                future growth goals, industry standards, and the size of the team.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>After finalizing the POS functionalities required by a specific business
                                                , our UI and UX designers work alongside developers and product
                                                strategists to develop layouts that establish solid technical
                                                foundations for code, product features, and automation.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>With a technically sound and battle-tested digital product, we deploy the
                                                system, connect analytics and bring the POS system to action. We further
                                                strengthen the features with post-launch evaluation and identify areas
                                                that can be automated and scaled.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Col>
                </Row>
            </Container>
        </section>
    )
        ;
}

export default Ourpractice;